import { type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { Textarea } from '~/components/ui/textarea'
import { ControlledFormItem } from './controlled-form-item'

type FormTextareaProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
  control: Control<TFieldValues>
  name: TName
  label?: string
  required?: boolean
  placeholder?: string
  rows?: number
  disabled?: boolean
}

export function FormTextarea<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  required,
  placeholder,
  rows = 3,
  disabled,
}: FormTextareaProps<TFieldValues, TName>) {
  return (
    <ControlledFormItem
      control={control}
      name={name}
      label={label}
      required={required}
      render={(field) => (
        <Textarea {...field} id={String(name)} placeholder={placeholder} rows={rows} disabled={disabled} />
      )}
    />
  )
}
